import React from 'react';
import { Link, useForm } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/components/ui/card';

export default function LoginForm() {
    const { data, setData, post, processing, errors } = useForm({
        email_address: '',
        password: '',
    });

    console.log("errors", errors)

    const handleSubmit = (e: React.SubmitEvent) => {
        e.preventDefault();
        post('/session');
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-2xl">Login</CardTitle>
                <CardDescription>
                    Enter your email below to login to your account
                </CardDescription>
            </CardHeader>
            <CardContent>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-6">
                        <div className="grid gap-2">
                            <Label htmlFor="email_address">Email</Label>
                            <Input
                                id="email_address"
                                type="email_address"
                                placeholder="m@example.com"
                                required
                                value={data.email_address}
                                onChange={(e) => setData('email_address', e.target.value)}
                            />

                        </div>
                        <div className="grid gap-2">
                            <div className="flex items-center">
                                <Label htmlFor="password">Password</Label>
                                <a
                                    href="/passwords/new"
                                    className="ml-auto inline-block text-sm underline-offset-4 hover:underline"
                                >
                                    Forgot your password?
                                </a>
                            </div>
                            <Input
                                id="password"
                                type="password"
                                required
                                value={data.password}
                                onChange={(e) => setData('password', e.target.value)}
                            />
                            {errors.password && (
                                <p className="text-sm text-red-500">{errors.password}</p>
                            )}
                        </div>
                        {errors.email_address && (
                            <p className="text-sm text-red-500">{errors.email_address}</p>
                        )}
                        <Button type="submit" className="w-full" disabled={processing}>
                            Login
                        </Button>
                    </div>
                    <div className="mt-4 text-center text-sm">
                        Don&apos;t have an account?{' '}
                        <Link href="/registrations/new" className="underline underline-offset-4">Sign up</Link>
                    </div>
                </form>
            </CardContent>
        </Card>
    );
}